import React from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Box,
  FormGroup,
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Link,
  InputLabel,
  FormHelperText,
} from "@material-ui/core";
import {
  FruProControllerPasswordField,
  FruProControllerTextField,
} from "@components";
import { Controller } from "react-hook-form";
import PhoneInput from "components/PhoneInput";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  userRegistration: {
    color: "#E77228",
    paddingTop: 30,
    paddingBottom: 20,
    fontSize: 27,
    fontWeight: 400,
  },
  root: {
    padding: "30px 36px 0",
  },
  phoneCodeTextField: {
    background: "white",
    display: "inline-block",
    width: "93px",
    borderRadius: 20,
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    height: "50px",
    "& .MuiInputBase-root": {
      padding: 20,
      borderRadius: 20,
      width: "93px",
      height: "50px",
      fontSize: "1rem",
      "&::before": {
        borderColor: theme.palette.default.main,
      },
    },
    "& .MuiInputBase-input": {
      paddingTop: 9,
      paddingLeft: "25px",
      paddingBottom: 9,
    },
    "& .MuiInputLabel-root": {
      fontWeight: 400,
    },
    "& input:-webkit-autofill": {
      backgroundColor: `${theme.palette.initial.main} !important`,
    },
    "&::before": {
      borderColor: theme.palette.default.main,
    },
  },
  phoneTextField: {
    background: "transparent",
    height: "100%",
    fontSize: 16,
    width: "100%",
    "& .MuiInputBase-root": {
      padding: 20,
      marginLeft: 25,
      borderRadius: 20,
      width: "268px",
      height: "50px",
      background: "white",
      fontSize: "1rem",
      "&::before": {
        borderColor: theme.palette.default.main,
      },
    },
    "& .MuiInputBase-input": {
      paddingTop: 9,
      paddingBottom: 9,
    },
    "& .MuiInputLabel-root": {
      fontWeight: 400,
    },
    "& input:-webkit-autofill": {
      backgroundColor: `${theme.palette.initial.main} !important`,
    },
    "&::before": {
      borderColor: theme.palette.default.main,
    },
  },
  customControlledField: {
    background: "transparent",
    height: "100%",
    fontSize: 16,
    width: "100%",
    "& .MuiInputBase-root": {
      padding: 20,
      borderRadius: 20,
      width: "366px",
      height: "50px",
      background: "white",
      fontSize: "1rem",
      "&::before": {
        borderColor: theme.palette.default.main,
      },
    },
    "& .MuiInputBase-input": {
      paddingTop: 9,
      paddingBottom: 9,
    },
    "& .MuiInputLabel-root": {
      fontWeight: 400,
    },
    "& input:-webkit-autofill": {
      backgroundColor: `${theme.palette.initial.main} !important`,
    },
    "&::before": {
      borderColor: theme.palette.default.main,
    },
  },
  basicInfoFields: {
    marginBottom: 24,
  },

  textCheckbox: {
    color: "#8d8d8d",
    fontSize: 13,
  },
  alreadyText: {
    color: theme.palette.error.errorA,
    fontSize: 16,
    marginBottom: 55,
  },
  linkText: {
    color: "#474646",
    fontWeight: 700,
  },
}));

export default function UserRegistrationForm({
  control,
  errors,
  watchCountry,
  countries,
  setValue,
  isHideCheckbox,
}) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.userRegistration}>User registration</Box>
      <Box className={classes.basicInfoFields}>
        <Grid container spacing={2}>
          <FruProControllerTextField
            className={classes.customControlledField}
            size={6}
            variant="standard"
            name="firstName"
            label="First Name"
            InputLabelProps={{ shrink: true, style: { color: "#000000" } }}
            control={control}
            error={!!errors.firstName}
            helperText={errors.firstName?.message}
            disableUnderline={true}
          />
          <FruProControllerTextField
            className={classes.customControlledField}
            size={6}
            name="lastName"
            label="Last Name"
            InputLabelProps={{ shrink: true, style: { color: "#000000" } }}
            control={control}
            error={!!errors.lastName}
            helperText={errors.lastName?.message}
            disableUnderline={true}
          />
          <FruProControllerTextField
            className={classes.customControlledField}
            size={6}
            name="email"
            InputLabelProps={{ shrink: true, style: { color: "#000000" } }}
            label="Email"
            control={control}
            error={!!errors.email}
            helperText={errors.email?.message}
            disableUnderline={true}
          />
          <Grid item xs={6} container>
            <Grid item xs={12}>
              <InputLabel
                style={{ color: "#000000" }}
                error={!!errors?.phoneNumber}
                shrink
              >
                Phone Number
              </InputLabel>
            </Grid>
            <Grid item xs={12}>
              <Grid spacing={8} container>
                <Grid item xs={2}>
                  <PhoneInput
                    className={classes.phoneCodeTextField}
                    label="Phone Number"
                    country={watchCountry}
                    countries={countries}
                    onChange={(event) =>
                      setValue("country", event.target.value)
                    }
                    disableUnderline={true}
                  />
                </Grid>
                <FruProControllerTextField
                  className={clsx({
                    [classes.phoneTextField]: true,
                    phoneNumber: true,
                  })}
                  size={10}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#000000" },
                  }}
                  name="phoneNumber"
                  placeholder="Phone Number"
                  control={control}
                  error={!!errors.phoneNumber}
                  helperText={errors.phoneNumber?.message}
                  disableUnderline={true}
                />
              </Grid>
            </Grid>
          </Grid>
          <FruProControllerPasswordField
            className={classes.customControlledField}
            size={6}
            name="password"
            label="Password"
            InputLabelProps={{ shrink: true, style: { color: "#000000" } }}
            control={control}
            error={!!errors.password}
            helperText={errors.password?.message}
            disableUnderline={true}
          />
          <FruProControllerPasswordField
            className={classes.customControlledField}
            size={6}
            name="confirmPassword"
            label="Confirm Password"
            InputLabelProps={{ shrink: true, style: { color: "#000000" } }}
            control={control}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
            disableUnderline={true}
          />
        </Grid>
      </Box>
      {!isHideCheckbox && (
        <FormGroup className={classes.checkboxGroup}>
          <Controller
            name="agree"
            control={control}
            render={({ field: { value, ...restField } }) => (
              <FormControlLabel
                classes={{
                  label: classes.textCheckbox,
                }}
                control={
                  <Checkbox
                    style={{ color: "#69CDAE" }}
                    color="primary"
                    checked={value}
                    {...restField}
                    size="small"
                  />
                }
                label={
                  <span>
                    I agree with{" "}
                    <a
                      style={{ color: "#69CDAE" }}
                      href="https://frupro.com/legal/terms-and-conditions/"
                      target="_blank"
                    >
                      FruPro terms and conditions
                    </a>
                    ,{" "}
                    <a
                      style={{ color: "#69CDAE" }}
                      href="https://frupro.com/legal/app-terms-and-conditions/"
                      target="_blank"
                    >
                      application terms and conditions
                    </a>
                    ,{" "}
                    <a
                      style={{ color: "#69CDAE" }}
                      href="https://frupro.com/legal/privacy-and-cookie-policy/"
                      target="_blank"
                    >
                      privacy and cookie policy
                    </a>
                  </span>
                }
                labelPlacement="end"
              />
            )}
          />
          {!!errors.agree && (
            <FormHelperText error={true}>{errors.agree.message}</FormHelperText>
          )}
          <Controller
            name="isReceiveEmail"
            control={control}
            error={!!errors.isReceiveEmail}
            render={({ field: { value, ...restField } }) => (
              <FormControlLabel
                classes={{
                  label: classes.textCheckbox,
                }}
                control={
                  <Checkbox
                    style={{ color: "#69CDAE" }}
                    color="primary"
                    checked={value}
                    {...restField}
                    size="small"
                  />
                }
                label="I agree to receive marketing, advertising and promotional information from FruPro"
                labelPlacement="end"
              />
            )}
          />
        </FormGroup>
      )}

      {/* <Typography className={classes.alreadyText} align="center">
        Already have an account?{" "}
        <Link href="/login">
          <span className={classes.linkText}>Login here.</span>
        </Link>
      </Typography> */}
    </Box>
  );
}
